import { FiscalDataUi } from '@/components/Buyer/BuyerProfile/PaymentAndFiscalData/FiscalData/FiscalDataUi';
import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import cacheKeys from '@/data/api/cacheKeys';
import { UpdateBuyerFiscalDataRequest } from '@/data/api/model/buyers/BuyersDto';
import { updateBuyerFiscalData } from '@/data/api/request/buyersRequests';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fiscalDataUiToUpdateBuyerFiscalDataRequest,
  requireFiscalDataToUpdateBuyerFiscalDataRequest,
} from './mapper';

export function useUpdateBuyerFiscalData() {
  const queryClient = useQueryClient();
  const { showSnackSuccess, showSnackError } = useSnackbarContext();

  const mutation = useMutation({
    mutationFn: async (args: {
      userId: string;
      request: UpdateBuyerFiscalDataRequest;
      successMessage: string;
    }) => updateBuyerFiscalData(args.userId, args.request),

    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.buyer.fiscalData, variables.userId],
      });
      const message = variables.successMessage;
      showSnackSuccess(message);
    },
    onError: () => showSnackError('Error, no se pudo realizar la operación'),
  });

  const updateRequiresTaxInvoice = (buyerId: string, requireFactura: boolean) =>
    mutation.mutate({
      userId: buyerId,
      request: requireFiscalDataToUpdateBuyerFiscalDataRequest(requireFactura),
      successMessage: requireFactura
        ? 'Facturación activada'
        : 'Facturación desactivada',
    });

  const updateFiscalData = (buyerId: string, fiscalDataUi: FiscalDataUi) =>
    mutation.mutate({
      userId: buyerId,
      request: fiscalDataUiToUpdateBuyerFiscalDataRequest(fiscalDataUi),
      successMessage: 'Datos fiscales actualizados',
    });

  return { updateRequiresTaxInvoice, updateFiscalData };
}
